import { Component, OnInit } from '@angular/core';
import { StatusChipComponent } from '../../../../../shared/components/status-chip/status-chip.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MapComponent } from '../../../../../shared/components/map/map.component';

@Component({
  selector: 'app-ambulance-confirmed',
  imports: [StatusChipComponent, MatIconModule, CommonModule, MapComponent],
  templateUrl: './ambulance-confirmed.component.html',
  styleUrl: './ambulance-confirmed.component.scss',
})
export class AmbulanceConfirmedComponent implements OnInit{
  
  expediente = '';
  fecha = '';
  hora = '';
  precio = '$0.00';
  cubierto = true;
  expanded = true;
  mapExpanded = true;
  hideHeaderDiv: boolean = false;
  serviceData: any = null;
  addressInfo: any = null;
  patientName: string = '';
  latitud: number | null = null;
  longitud: number | null = null;
  direccionReal: string = '';
  telefono: string = '';

  constructor(private router: Router) {}

  ngOnInit(): void {
    console.log("estoy mandando la asistencia");
    
    // Intentar obtener datos del estado de navegación actual
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.processNavigationState(nav.extras.state);
    } else {
      // Si no hay navegación actual, intentar obtener del historial
      const currentState = history.state;
      if (currentState && Object.keys(currentState).length > 1) {
        this.processNavigationState(currentState);
      }
    }
    
    console.log('Service data:', this.serviceData);
    console.log('Address info:', this.addressInfo);
    console.log('Coordenadas finales:', { lat: this.latitud, lng: this.longitud });
  }
  
  processNavigationState(state: any) {
    if (state['fromSelection']) {
      this.hideHeaderDiv = true;
    }
    
    // Obtener datos del servicio si están disponibles
    if (state['serviceResponse']) {
      this.serviceData = state['serviceResponse'];
      this.processServiceData();
    }
    
    // Obtener información de dirección y paciente
    this.addressInfo = state['address'];
    this.patientName = state['patient'] || '';
  }
  
  processServiceData() {
    console.log('Processing service data:', this.serviceData);
    
    if (this.serviceData) {
      let data = this.serviceData;
      
      // Si los datos están dentro de 'response', usar esos
      if (this.serviceData.response) {
        data = this.serviceData.response;
      }
      
      console.log('Data to process:', data);
      
      // Procesar expediente
      if (data.id) {
        this.expediente = `#${data.id}`;
        console.log('Expediente set to:', this.expediente);
      }
      
      // Procesar fecha y hora
      if (data.fechaapertura) {
        const fechaCompleta = new Date(data.fechaapertura);
        this.fecha = fechaCompleta.toLocaleDateString('es-ES');
        this.hora = fechaCompleta.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
        console.log('Fecha y hora set to:', this.fecha, this.hora);
      }
      
      // Procesar coordenadas
      if (data.latitud && data.longitud) {
        this.latitud = parseFloat(data.latitud);
        this.longitud = parseFloat(data.longitud);
        console.log('Coordenadas set to:', this.latitud, this.longitud);
      }
      
      // Procesar dirección
      if (data.direccion) {
        this.direccionReal = data.direccion;
        console.log('Dirección set to:', this.direccionReal);
      }
      
      // Procesar teléfono
      if (data.telefono1) {
        this.telefono = data.telefono1;
        console.log('Teléfono set to:', this.telefono);
      }
      
      // El precio se mantiene cubierto por el programa
      this.cubierto = true;
    } else {
      console.log('No service data available');
    }
    
    // También procesar desde addressInfo si está disponible
    if (this.addressInfo) {
      this.direccionReal = this.addressInfo.address || this.direccionReal;
      this.latitud = this.addressInfo.lat || this.latitud;
      this.longitud = this.addressInfo.lng || this.longitud;
    }
    
    // Valores por defecto para testing si no hay coordenadas
    if (!this.latitud || !this.longitud) {
      this.latitud = 19.6078216;
      this.longitud = -99.73999;
      this.direccionReal = this.direccionReal || 'Ubicación del servicio';
      console.log('Usando coordenadas por defecto para testing');
    }
  }

  toggleExpand() {
    this.expanded = !this.expanded;
  }

  toggleMap() {
    this.mapExpanded = !this.mapExpanded;
  }

  contactar() {
    if (this.telefono) {
      window.location.href = `tel:${this.telefono}`;
    } else {
      console.log('No hay teléfono disponible');
    }
  }

  getMapUrl(): string {
    if (this.latitud && this.longitud) {
      // Usar Google Maps Embed con coordenadas específicas
      return `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1000!2d${this.longitud}!3d${this.latitud}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1ses!2smx`;
    }
    return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3762.8!2d-99.74!3d19.608!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDM2JzI4LjgiTiA5OcKwNDQnMjQiVw!5e0!3m2!1ses!2smx!4v1234567890';
  }
}
